import { render, staticRenderFns } from "./AddPurc.vue?vue&type=template&id=98b8c054&scoped=true&"
import script from "./AddPurc.vue?vue&type=script&lang=js&"
export * from "./AddPurc.vue?vue&type=script&lang=js&"
import style0 from "./AddPurc.vue?vue&type=style&index=0&id=98b8c054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b8c054",
  null
  
)

export default component.exports